import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import * as fromContainers from './containers';

const routes: Routes = [
    {
        path: '',
        component: fromContainers.LiteraturesComponent
    },
    {
        path: ':literatureId',
        component: fromContainers.LiteraturesDetailComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class LiteratureRoutingModule {}
